<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.qrCode' style='width: 125px;' placeholder='标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.outerQRCode' style='width: 125px;' placeholder='外箱标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='false'
      :expandRowKeys='mainTable.expandRowKeys'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='(qrCode, qrCodeIndex) in scope.data.row.detailDt1'
            :key='qrCode.QRCode' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'>{{qrCodeIndex + 1}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'>{{qrCode.QRCode}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{qrCode.Qty}}{{qrCode.BU_Name}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'>{{qrCode.OuterQRCode}} </span></div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'>{{qrCode.SupplyBatchNo}} </span></div>
          </div>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'

export default {
  name: 'POInstockEntry',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_POInstockEntry',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        qrCode: '',
        outerQRCode: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      }
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.qrCode) {
        const qrCodes = that.mainTable.qrCode.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < qrCodes.length; i++) {
          detail1FilterStr += " OR QRCode LIKE '%" + qrCodes[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.outerQRCode) {
        const outerQRCodes = that.mainTable.outerQRCode.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < outerQRCodes.length; i++) {
          detail1FilterStr += " OR OuterQRCode LIKE '%" + outerQRCodes[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      return {}
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
</style>
